export const relinkOnChangeComponentModule = angular
  .module('Q.components.relink-on-change', [])

  /**
   * This directive can be used to force child directives to relink if the provided value changes.
   *
   * It does this by destroying the existing elements and scope, and transcluding them back, similar to
   * how ngIf works, but with a more focused design.
   */
  .directive('relinkOnChange', function () {
    return {
      restrict: 'A',
      transclude: 'element',
      priority: 600, // equal to ng-if
      link($scope, $element, $attr, ctrl, $transclude) {
        let childScope;
        let previousElements;
        $scope.$watch($attr.relinkOnChange, function (val, oldVal) {
          if (val !== oldVal) {
            if (previousElements) {
              previousElements.remove();
            }
            if (childScope) {
              childScope.$destroy();
            }
          }

          $transclude(function (clone, newScope) {
            childScope = newScope;
            previousElements = clone;
            // this tries to prevent the dom element ordering from getting screwed up
            if ($element[0].parentNode && $element[0].previousElementSibling) {
              $element.after(clone);
            } else {
              $element.parent().prepend(clone);
            }
          });
        });
      },
    };
  });
